/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiagnosisAliases {
  AUTOCOMPLETE_TYPE_PRESENTATION = 'autocomplete-type-presentation',
  BUTTON_ADD_DIAGNOSIS = 'button-add-diagnosis',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_END_DATE = 'date-picker-end-date',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  DECK_DIAGNOSIS = 'deck-diagnosis',
  DIAGNOSIS_CARD = 'diagnosis-card',
  FETCH_DIAGNOSIS = 'fetch-diagnosis',
  FIELD_TYPE_PRESENTATION = 'field-type-presentation',
  FILTER_DIAGNOSIS = 'filter-diagnosis',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_DIAGNOSIS = 'layout-diagnosis',
  LEGENDS_DIAGNOSIS = 'legends-diagnosis',
  MAPPER_TYPE_PRESENTATION = 'mapper-type-presentation',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  TEXT_TYPE_PRESENTATION = 'text-type-presentation',
}
export { DiagnosisAliases };
